import { useState } from 'react'

import { IconDownload, IconMenu2 } from '@tabler/icons-react'

import type { Page } from '@subaio/utils'

import { GridRow } from 'components/Layout'

import { ButtonDownload } from './ButtonDownload'
import { Container } from './Container'
import { DownloadLabel } from './DownloadLabel'
import { ExpandLink } from './ExpandLink'
import { FloatingMenuButton } from './FloatingMenuButton'
import { Link } from './Link'
import { OrderedList } from './OrderedList'
import { Title } from './Title'

export type Heading = {
	title: string
	id: string
	description?: string
}

type Props = {
	title: string
	pageName: string
	pageParams: Page['params']
	headings: Array<
		Heading & {
			paths: Array<Heading & { method: string }>
		}
	>
	fragment: string | undefined

	onDownloadJson: () => void
	onDownloadYaml: () => void
}

export const Navigation = ({
	title,
	pageName,
	pageParams,
	headings,
	fragment,
	onDownloadJson,
	onDownloadYaml,
}: Props) => {
	const [isMenuVisible, setIsMenuVisible] = useState(false)

	return (
		<>
			<Container id='navigation' style={{ left: isMenuVisible ? 0 : '-280px' }}>
				<Title>
					<Link name={pageName} params={pageParams}>
						{title}
					</Link>
				</Title>
				<GridRow gap={0}>
					<ButtonDownload
						label={
							<DownloadLabel>
								<IconDownload size={16} /> YAML
							</DownloadLabel>
						}
						onClick={onDownloadYaml}
					/>
					<ButtonDownload
						label={
							<DownloadLabel>
								<IconDownload size={16} /> JSON
							</DownloadLabel>
						}
						onClick={onDownloadJson}
					/>
				</GridRow>
				<OrderedList>
					{headings.map(({ title, id, paths }) => (
						<ExpandLink
							key={id}
							name={pageName}
							params={pageParams}
							title={title}
							id={id}
							paths={paths}
							fragment={fragment}
						/>
					))}
				</OrderedList>
			</Container>
			<FloatingMenuButton icon={<IconMenu2 />} onClick={() => setIsMenuVisible(!isMenuVisible)} />
		</>
	)
}
